"use client";

import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/app/_components/ui/input-otp";
import { cn } from "@/lib/utils";
import { forwardRef } from "react";

const CODE_SLOTS = [0, 1, 2, 3, 4, 5];

/** Six 58px boxes for a one-time code; all six turn red on an error. */
export const CodeInput = forwardRef<
  HTMLInputElement,
  {
    value: string;
    onChange: (value: string) => void;
    onBlur?: () => void;
    name?: string;
    disabled?: boolean;
    hasError?: boolean;
  }
>(({ hasError = false, ...props }, ref) => (
  <InputOTP ref={ref} maxLength={6} autoComplete="one-time-code" {...props}>
    <InputOTPGroup className="grid w-full grid-cols-6 gap-2">
      {CODE_SLOTS.map((index) => (
        <InputOTPSlot
          key={index}
          index={index}
          className={cn(
            "h-[58px] w-full rounded-[10px] border bg-white text-[22px] font-semibold text-[#1a1a1a] first:rounded-l-[10px] first:border-l last:rounded-r-[10px]",
            hasError ? "border-[#e2a39b]" : "border-[#d3d9dc]",
            "ring-[rgba(125,111,208,0.35)] ring-offset-0",
          )}
        />
      ))}
    </InputOTPGroup>
  </InputOTP>
));
CodeInput.displayName = "CodeInput";
